import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Nav, TopBanner } from '@outdoor-voices/ui';
import Customer from '@outdoor-voices/ui/dist/utils/Customer';
import React from 'react';
import ReactDOM from 'react-dom';
import { JWT_COOKIE_NAME } from '../customers/constants';
import { getAccessToken, getProgram } from '../customers/utils';
import { OV_GRAPHQL_URL, OV_ID_URL } from '../../config/theme';
import Footer from '../../components/Footer';
import jwtDecode from 'jwt-decode';
import removeClass from '../../utils/dom/removeClass';
import WishListCache from '../customers/WishListCache';
import { jsx as _jsx } from "react/jsx-runtime";

var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window, OV, _document, body, navWrap, CUSTOMER, FOOTER_PROPS, NAV, TOP_BANNER_PROPS, customer, token, loggedIn, renderNav, topBannerId, topBanner, program, messages, primaryColor, secondaryColor, footerRoot, cache, cacheResults;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _window = window, OV = _window.OV;
            _document = document, body = _document.body;
            navWrap = document.querySelector('.ov-nav-wrap');
            CUSTOMER = OV.CUSTOMER, FOOTER_PROPS = OV.FOOTER_PROPS, NAV = OV.NAV, TOP_BANNER_PROPS = OV.TOP_BANNER_PROPS;
            customer = new Customer();
            token = getAccessToken();
            loggedIn = token !== undefined;

            renderNav = function renderNav() {
              // Render the nav
              if (navWrap === null) {
                return;
              }

              token = getAccessToken();
              loggedIn = token !== undefined;
              var firstName = token ? jwtDecode(token).firstName : '';
              ReactDOM.render( /*#__PURE__*/_jsx(Nav, {
                apiURL: OV_GRAPHQL_URL,
                bagCount: NAV.bagCount,
                firstName: firstName,
                loggedIn: loggedIn,
                onLogin: renderNav,
                nav: NAV,
                ovIdURL: OV_ID_URL,
                shopURL: "/"
              }), navWrap);
            };

            renderNav(); // Render the top banner

            topBannerId = 'top-banner';

            if (!(TOP_BANNER_PROPS !== null && TOP_BANNER_PROPS !== void 0 && TOP_BANNER_PROPS.noTopBanner)) {
              _context.next = 16;
              break;
            }

            topBanner = document.getElementById(topBannerId);
            if (topBanner) topBanner.parentNode.removeChild(topBanner);
            removeClass(body, topBannerId);
            _context.next = 23;
            break;

          case 16:
            removeClass(body, "no-".concat(topBannerId));
            program = getProgram();
            messages = [];

            if (loggedIn && program) {
              primaryColor = program.primaryColor, secondaryColor = program.secondaryColor;
              messages = [{
                backgroundColor: primaryColor,
                cta: 'Go Now',
                displayArrow: true,
                id: 'ovu',
                rawHtml: '',
                title: 'Take 20% Off Sitewide With OVU.',
                titleColor: secondaryColor,
                url: '/collections/ov-edu'
              }];
            }

            if (document.getElementById(topBannerId)) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return");

          case 22:
            ReactDOM.render( /*#__PURE__*/_jsx(TopBanner, {
              apiURL: OV_GRAPHQL_URL,
              jwtCookieName: JWT_COOKIE_NAME,
              messages: messages
            }), document.getElementById(topBannerId));

          case 23:
            // Render the footer
            footerRoot = document.getElementById('footer');

            if (footerRoot !== null) {
              ReactDOM.render( /*#__PURE__*/_jsx(Footer, _objectSpread(_objectSpread({}, FOOTER_PROPS), {}, {
                loggedIn: CUSTOMER.loggedIn
              })), footerRoot);
            } // Setup the customer


            customer.updateCustomerVisitsCookies();

            if (CUSTOMER.loggedIn) {
              customer.reconcilePurchases(CUSTOMER.orderCount);
            }

            customer.storeInGlobalObject();

            window.onbeforeunload = function () {
              customer.updatePreviousVisitCookie();
            }; // Manage the wish list cache


            cache = new WishListCache();
            cacheResults = cache.get(); // Load the wish lists if they are logged in  without data

            if (!(loggedIn && !cacheResults.loaded)) {
              _context.next = 34;
              break;
            }

            _context.next = 34;
            return cache.load();

          case 34:
            // Clear the results if they have data but aren't logged in
            if (!loggedIn && cacheResults.loaded) {
              cache.clear();
            }

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();

export default init;